import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));


//content-security-policy
const csp = document.createElement('meta')
let mycontent = `default-src 'self' https://api.ipify.org;
script-src 'self' https://code.jquery.com https://cdn.jsdelivr.net  https://cdnjs.cloudflare.com https://stackpath.bootstrapcdn.com https://maps.googleapis.com https://maxcdn.bootstrapcdn.com 'unsafe-inline';
style-src 'self'  https://fonts.googleapis.com https://stackpath.bootstrapcdn.com  https://cdnjs.cloudflare.com 'unsafe-inline';
font-src 'self' https://fonts.googleapis.com  https://fonts.gstatic.com;
connect-src 'self' ws: wss: https://*.googleapis.com https://*.firebase.com https://api.ipify.org http://localhost:3000 https://acms.upda.co.in:3010 https://acms.upda.co.in/api http://localhost:3004 http://localhost:3088 https://maps.googleapis.com https://cdnjs.cloudflare.com https://newerp.upneda.co:3046 https://uat.erp2.upda.co.in:3006 https://preprod.erp2.upda.co.in:3006 https://dev.upda.co.in:3016 https://preprod.erp2.upda.co.in:3006/ https://icds.upda.co.in:3016 https://preprod.erp2.upda.co.in:3006/ https://lda.upda.co.in:3022 https://property.upda.co.in:3022 https://sealing.upda.co.in:3014 https://tracking.upda.co.in:3026 https://erp2.upda.co.in:3015 https://erplda.upda.co.in:3032 https://testing.upda.co.in:3021 https://preprod.erp.upneda.co:3012 https://erp.upneda.co:3030 https://dev.acms.upda.co.in:3014 https://dev.acms.upda.co.in/api https://uat.erp.upneda.co:3035;
img-src 'self' data: https://api.ipify.org blob: http://localhost:3000 https://acms.upda.co.in:3010 https://dev.acms.upda.co.in:3014;`

csp.setAttribute('http-equiv', 'Content-Security-Policy');
csp.setAttribute('content', mycontent);
document.head.appendChild(csp)


// Create and append the meta tag & links
const faviconLink = document.createElement('link');
faviconLink.setAttribute('rel', 'icon');
faviconLink.setAttribute('type', 'image/x-icon');
faviconLink.setAttribute('href', './assets/img/pcs_logo.jpg');
document.head.appendChild(faviconLink);

// const script = document.createElement('script');
// script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBFYlyaMdqSA-Iz92VL0X21l133iHDtjTo&libraries=places&language=en');
// document.head.appendChild(script);


// const cdnBts = document.createElement('script');
// cdnBts.setAttribute('src', 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/js/bootstrap.min.js');
// document.head.appendChild(cdnBts);



// const googleFont1 = document.createElement('link');
// googleFont1.setAttribute('rel', 'stylesheet');
// googleFont1.setAttribute('href', 'https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap');
// document.head.appendChild(googleFont1);


// const csvScript = document.createElement('script');
// csvScript.setAttribute('src', './assets/js/scripts/CSVExport.js');
// document.head.appendChild(csvScript);

